var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuyCredit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 20,
    fill: "#FDE2E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 33H51.5M22.1 24H47.9C48.8548 24 49.7705 24.3793 50.4456 25.0544C51.1207 25.7295 51.5 26.6452 51.5 27.6V44.4C51.5 45.3548 51.1207 46.2705 50.4456 46.9456C49.7705 47.6207 48.8548 48 47.9 48H22.1C21.1452 48 20.2295 47.6207 19.5544 46.9456C18.8793 46.2705 18.5 45.3548 18.5 44.4V27.6C18.5 26.6452 18.8793 25.7295 19.5544 25.0544C20.2295 24.3793 21.1452 24 22.1 24Z",
    stroke: "url(#paint0_linear_1471_7218)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1471_7218",
    x1: 18.5,
    y1: 36,
    x2: 51.5,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyCredit);
export default __webpack_public_path__ + "static/media/buy_credit.41cfb7dc6fce90d70e3fdf3564aa9c62.svg";
export { ForwardRef as ReactComponent };